module.exports = __webpack_public_path__ + "img/games-2.2945bc19.jpg";